const ATTACHMENTS_DIR = 'attachments'

/**
 * Convert a relative URL to a safe flat filename under the attachments directory.
 * Strips query strings / fragments, replaces `/` with `_`, strips the leading slash.
 *
 * Example: `/media/images/abc123.jpg?token=x` → `attachments/media_images_abc123.jpg`
 */
export function toAttachmentFilePath(relativeUrl: string): string {
  if (!relativeUrl || relativeUrl.trim() === '') {
    throw new Error('Cannot convert empty URL to attachment file path')
  }

  const urlPath = relativeUrl.split('?')[0].split('#')[0]
  const sanitized = urlPath.replace(/^\//, '').replace(/\//g, '_')

  if (!sanitized) {
    throw new Error(`Cannot convert URL to safe file path: ${relativeUrl}`)
  }

  return `${ATTACHMENTS_DIR}/${sanitized}`
}

export { ATTACHMENTS_DIR }
